import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {
  className?: string;
  color?: string;
}

const ChevronDown: React.FC<Props> = ({ className, color = '#000000' }) => (
  <SVGIcon viewBox="6 -2 30 30" className={className}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill={color} fillRule="nonzero">
        <path d="M10.21875,5.78125 L8.78125,7.21875 L21.28125,19.71875 L22,20.40625 L22.71875,19.71875 L30.3739778,12.0635222 L35.21875,7.21875 L33.78125,5.78125 L22,17.5625 L10.21875,5.78125 Z" />
      </g>
    </g>
  </SVGIcon>
);

export default ChevronDown;
